/*
 * Copyright (c) 2023 ACG Business Analytics Inc. All rights reserved.
 *
 * This file is part of a proprietary software system of ACG Business Analytics Inc.
 * No part of this file may be copied, modified, sold, distributed, or used in any
 * way without the written permission of ACG Business Analytics Inc.
 *
 */
import * as Sentry from '@sentry/react';
import { createRoot } from 'react-dom/client';

import App from '@/app';

import './globals.css';

const container = document.getElementById('root');
const root = createRoot(container!);

// https://vitejs.dev/guide/build.html#load-error-handling
window.addEventListener('vite:preloadError', () => {
    window.location.reload();
});

Sentry.init({
    environment: import.meta.env.VITE_BAE_ENVIRONMENT || 'localhost',
    release:
        'bae-frontend@' + (import.meta.env.VITE_BAE_VERSION || 'localhost'),
    dsn: import.meta.env.VITE_SENTRY_DSN,
    integrations: [
        Sentry.browserTracingIntegration(),
        Sentry.replayIntegration({
            maskAllText: false,
            maskAllInputs: false,
            blockAllMedia: false,
        }),
        Sentry.replayCanvasIntegration(),
        Sentry.httpClientIntegration({
            failedRequestStatusCodes: [400, 401, 403, 404, 500],
        }),
        Sentry.extraErrorDataIntegration(),
    ],

    sendDefaultPii: true,

    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    tracesSampleRate: 1.0,

    // Capture Replays for 0% of all sessions,
    // plus for 100% of sessions with an error
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 1.0,
});

// STRICT MODE WILL CAUSE SOME FRICTION WITH THE AUTH FLOW, REDIRECTING AGAIN TO LOGIN PAGE SOMETIMES
// BUT IT WILL AFFECT ONLY THE DEVELOPMENT ENVIRONMENT
root.render(<App />);
